import classNames from "classnames";

type BadgeTone = "primary" | "soft" | "success" | "warning" | "error" | "info";

interface Props {
	tone?: BadgeTone;
	showDot?: boolean;
	children: React.ReactNode;
}

export default function Badge({ tone = "primary", showDot, children }: Props) {
	return (
		<div
			className={classNames(
				"py-1 px-3 rounded-full text-sm font-medium w-fit flex flex-row items-center gap-1.5",
				{
					"bg-primary text-primary-front": tone === "primary",
					"bg-primary-plain text-primary": tone === "soft",
					"bg-success-plain text-success": tone === "success",
					"bg-warning-plain text-warning": tone === "warning",
					"bg-error-plain text-error": tone === "error",
					"bg-background-active text-front": tone === "info",
				}
			)}
		>
			{showDot && (
				<span
					className={classNames("size-2 rounded-full", {
						"bg-primary-front": tone === "primary",
						"bg-primary": tone === "soft",
						"bg-success": tone === "success",
						"bg-warning": tone === "warning",
						"bg-error": tone === "error",
						"bg-front": tone === "info",
					})}
				/>
			)}

			{children}
		</div>
	);
}
